module.exports = __webpack_public_path__ + "img/logo.c0cd21b7.png";